<template>
  <v-layout align-start>
    <v-flex>
      <v-toolbar text color="white">
        <v-toolbar-title>Clientes</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          class="text-xs-center"
          v-model="search"
          append-icon="search"
          label="Búsqueda"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <!--Modal agregar o editar clientes-->
        <ModalCliente
          @save="guardar"
          @close="close"
          :object="itemAct"
          :show="dialog"
          :update="update"
          :detalle="detalle"
        />
        <!--Modal activar, desactivar, eliminar-->
        <v-dialog v-model="adModal" max-width="290">
          <v-card>
            <v-card-title class="headline" v-if="adAccion == 1"
              >Activar Item</v-card-title
            >
            <v-card-title class="headline" v-if="adAccion == 2"
              >Desactivar Item</v-card-title
            >
            <v-card-title class="headline" v-if="adAccion == 3"
              >Eliminar Cliente</v-card-title
            >
            <v-card-text>
              Estás a punto de
              <span v-if="adAccion == 1">activar</span>
              <span v-if="adAccion == 2">desactivar</span>
              <span v-if="adAccion == 3">eliminar</span>
              el item {{ adNombre }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                @click="activarDesactivarCerrar()"
                color="green darken-1"
                text="text"
                >Cancelar</v-btn
              >
              <v-btn
                v-if="adAccion == 1"
                @click="activar()"
                color="orange darken-4"
                text="text"
                >Activar</v-btn
              >
              <v-btn
                v-if="adAccion == 2"
                @click="desactivar()"
                color="orange darken-4"
                text="text"
                >Desactivar</v-btn
              >
              <v-btn
                v-if="adAccion == 3"
                @click="eliminarCliente()"
                color="orange darken-4"
                text="text"
                >Eliminar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="clientes"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:item.opciones="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" v-on="on" @click="editItem(item)"
                >edit</v-icon
              >
            </template>
            <span>Editar cliente</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div v-if="item.estado">
                <v-icon
                  small
                  v-on="on"
                  @click="activarDesactivarMostrar(2, item)"
                  >block</v-icon
                >
              </div>
              <div v-else>
                <v-icon small @click="activarDesactivarMostrar(1, item)"
                  >check</v-icon
                >
              </div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    small
                    class="mr-2"
                    v-on="on"
                    @click="activarDesactivarMostrar(3, item)"
                    >delete</v-icon
                  >
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>
            <span>{{ item.estado ? "Desactivar" : "Activar" }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.estado="{ item }">
          <div v-if="item.estado">
            <span class="blue--text">Activo</span>
          </div>
          <div v-else>
            <span class="red--text">Inactivo</span>
          </div>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="llamarClientes()">Resetear</v-btn>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";
import ModalCliente from "./base/modals/ModalCliente";
// import bus from "@/EventBus";

export default {
  data() {
    return {
      dialog: false,
      update: false,
      detalle: false,
      search: "",
      headers: [
        { text: "Opciones", value: "opciones", sortable: false },
        { text: "Nombre", value: "nombre", sortable: true },
        { text: "Tipo Cliente", value: "tipo_cliente", sortable: true },
        { text: "Tipo Documento", value: "tipo_documento", sortable: true },
        { text: "Número Documento", value: "num_documento", sortable: false },
        { text: "Dirección", value: "direccion", sortable: false },
        { text: "Zona", value: "zona", sortable: false },
        { text: "Teléfono", value: "telefono", sortable: false },
        { text: "Email", value: "email", sortable: false },
        { text: "Estado", value: "estado", sortable: false },
      ],
      editedIndex: -1,
      itemAct: {
        _id: null,
        nombre: null,
        tipo_persona: "Cliente",
        tipo_cliente: null,
        tipo_documento: null,
        documentos: ["DNI", "RUC", "PASAPORTE", "CEDULA"],
        num_documento: null,
        direccion: null,
        zona: null,
        telefono: null,
        email: null,
      },
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
    };
  },
  components: {
    ModalCliente,
  },
  computed: {
    ...mapState("usuarioNamespace", ["token"]),
    ...mapState("clienteNamespace", ["clientes"]),
  },
  methods: {
    ...mapActions("clienteNamespace", [
      "getClientes",
      "saveCliente",
      "updateCliente",
      "activateCliente",
      "deactivateCliente",
      "deleteCliente",
    ]),
    llamarClientes() {
      let Token = this.token;
      this.getClientes(Token);
    },
    
    guardar(obj) {
      if (this.editedIndex > -1) {
        //Código para editar
        this.updateCliente({
          token: this.token,
          obj: obj
        });
        this.close();
      } else {
        //Código para guardar
        this.saveCliente({
          token: this.token,
          obj: obj
        });
        this.close();
      }
    },
    activar() {
      this.activateCliente({
        token: this.token,
        _id: this.adId,
      });

      this.adModal = 0;
      this.adAccion = 0;
      this.adNombre = "";
      this.adId = "";
    },
    desactivar() {
      this.deactivateCliente({
        token: this.token,
        _id: this.adId,
      });

      this.adModal = 0;
      this.adAccion = 0;
      this.adNombre = "";
      this.adId = "";
    },
    editItem(item) {
      this.update = true
      this.itemAct = item;
      this.dialog = true;
      this.editedIndex = 1;
    },
    activarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.adNombre = item.nombre;
      this.adId = item._id;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else if (accion == 3) {
        this.adAccion = 3;
      } else {
        this.adModal = 0;
      }
    },
    activarDesactivarCerrar() {
      this.adModal = 0;
    },
    eliminarCliente() {
      this.deleteCliente({
        token: this.token,
        id: this.adId,
      });
      this.adModal = 0;
      this.adAccion = 0;
      this.adNombre = "";
      this.adId = "";
    },
    close() {
      this.detalle = false;
      this.update = false;
      this.itemAct = {};
      this.dialog = false;
      this.editedIndex = -1;
    },
  },
};
</script>
